export default [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/my/profile.vue')
  },
  {
    path: '/my/address',
    name: 'myaddress',
    component: () => import('@/views/my/address.vue')
  },
  {
    path: '/my/address/detail',
    name: 'myaddressdetail',
    component: () => import('@/views/my/addressdetail.vue')
  },
  {
    path: '/my/order',
    name: 'myorder',
    component: () => import('@/views/order/orderlist.vue')
  },
  {
    path: '/my/clazz',
    name: 'myclazz',
    component: () => import('@/views/my/clazz.vue')
  },
  {
    path: '/my/race',
    name: 'myrace',
    component: () => import('@/views/my/race.vue')
  },
  {
    path: '/my/record',
    name: 'myrecord',
    component: () => import('@/views/record/myrecord.vue')
  },
  {
    path: '/my/review/record',
    name: 'myreviewrecord',
    component: () => import('@/views/record/myreviewrecord.vue')
  }
]
